<div *ngIf="pdf_url" class="relative-pdf-page">
    <iframe
        [src]="pdf_url | safe"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        frameborder="0"
        [ngClass]="{ 'height-99vh': hide_header_footer }"
    ></iframe>
    <!-- <ngx-extended-pdf-viewer
        src="../../../assets/compressed.tracemonkey-pldi-09.pdf"
        pageViewMode="book"
        [spread]="'off'"
        zoom="page-fit"
        [showBorders]="true"
        [useBrowserLocale]="true"
        [showToolbar]="true"
        [showSidebarButton]="true"
        [showFindButton]="false"
        [showPagingButtons]="true"
        [showZoomButtons]="false"
        [showPresentationModeButton]="false"
        [showOpenFileButton]="false"
        [showPrintButton]="false"
        [showDownloadButton]="true"
        [showBookmarkButton]="false"
        [showSecondaryToolbarButton]="false"
        [showRotateButton]="false"
        [showHandToolButton]="false"
        [showScrollingButton]="false"
        [showSpreadButton]="false"
        [showPropertiesButton]="false"
        [mobileFriendlyZoom]="zoom"
        [enablePinchOnMobile]="true"
        [minZoom]="0.5"
        [maxZoom]="1.5"
    ></ngx-extended-pdf-viewer> -->
</div>
<app-loading *ngIf="loadingPdf"></app-loading>
<!-- <img  loading="lazy"  src="../../../assets/sample.pdf"    alt=""> -->
